import { JobTitle } from "domain/entities/job-title";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface JobTitleState {
  jobTitle: JobTitle[];
  setJobTitle: (newJobTitle: JobTitle[] | undefined) => void;
}

export const useJobTitleStore = create<JobTitleState>()(
  devtools(
    (set) => ({
      jobTitle: [],
      setJobTitle: (newJobTitle) =>
        set(() => ({
          jobTitle: newJobTitle ? [...newJobTitle] : [],
        })),
    }),
    { name: "JobTitleStore" }
  )
);
